import { BfEventClass, BfMapId, BfMapLayerGroupId } from "@/lib/api/models";
import { BfMapboxGeojsonFeature } from "@/lib/types";

export enum SidebarMode {
    IncidentsAndWarnings = "IncidentsAndWarnings",
    CustomLayerEditor = "CustomLayerEditor",
}

export type SidebarEventGroup = {
    sidebarMode: SidebarMode;
    class?: BfEventClass;
    layerGroup: BfMapLayerGroupId;
    events: BfMapboxGeojsonFeature[];
};

export const StandardSidebarGroups: SidebarEventGroup[] = [
    {
        sidebarMode: SidebarMode.IncidentsAndWarnings,
        class: BfEventClass.warning,
        layerGroup: BfMapLayerGroupId.warnings,
        events: [],
    },
    {
        sidebarMode: SidebarMode.IncidentsAndWarnings,
        class: BfEventClass.advisory,
        layerGroup: BfMapLayerGroupId.weatherWarnings,
        events: [],
    },
    {
        sidebarMode: SidebarMode.IncidentsAndWarnings,
        class: BfEventClass.incident,
        layerGroup: BfMapLayerGroupId.incidents,
        events: [],
    },
    {
        sidebarMode: SidebarMode.CustomLayerEditor,
        layerGroup: BfMapLayerGroupId.customLayers,
        events: [],
    },
];

export enum HandlebarsTemplateType {
    Title,
    Body,
    Subtitle,
    Image,
}

export const SidebarModeMap: Record<BfMapId, SidebarMode> = {
    main: SidebarMode.IncidentsAndWarnings,
    notification: SidebarMode.IncidentsAndWarnings,
    manage: SidebarMode.IncidentsAndWarnings,
    managePreview: SidebarMode.IncidentsAndWarnings,
    customLayerEditor: SidebarMode.CustomLayerEditor,
};
